import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {Router} from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  showErrorMessage = false;
  showSuccess = false;
  constructor(public auth: AngularFireAuth, private router: Router) { }

  ngOnInit() {
  }

  sendResetPasswordEmail() {
    this.showErrorMessage = false;
    this.showSuccess = false;
    this.auth.auth.sendPasswordResetEmail(this.email).then(() => {
      // Email sent.
      this.showSuccess = true;
    }).catch((error) => {
      // An error happened.
      this.showErrorMessage = true;
    });
  }

}
